<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Created Date"
            label-for="created_at"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['created_at']"
                :opens="'right'"
                @update="updateDateRange('created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Status"
            label-for="status"
          >
            <v-select
              v-model="filters['status']"
              :options="statusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>
    <b-card
      no-body
    >
      <b-overlay
        :show="submitLoading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <div
          class="m-2"
        >
          <b-row
            cols="12"
            class="pt-1 pb-1"
          >
            <b-col
              class="justify-content-end"
            >
              <b-row
                class="d-flex align-items-center justify-content-end mr-1"
              >
                <b-col class="d-flex justify-content-start">
                  <div
                    class="font-weight-bolder text-muted mobile-margin"
                  >
                    {{ `${invoiceSelected.length} record${invoiceSelected.length === 1 ? '':'s'}` }} selected
                  </div>
                </b-col>
                <b-col md="3">
                  <v-select
                    v-model="selectedMerchant"
                    :options="merchantOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select Merchant"
                    class="ml-1 mobile-margin"
                    @input="getMerchantBusinessList()"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-col>
                <!-- new filter called merchant business -->
                <b-col md="3">
                  <v-select
                    v-model="selectedMerchantBusiness"
                    :options="merchantBusinessOptions"
                    :reduce="option => option.id"
                    label="business_name"
                    class="ml-1 mobile-margin"
                    placeholder="Select Business"
                  >
                    <template v-slot:option="option">
                      {{ option.business_name }}
                    </template>
                  </v-select>
                </b-col>

                <div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color-blur mobile-margin mr-2"
                    @click="loadBills"
                  >
                    Get Invoices
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="custom-button-color mobile-margin"
                    :disabled="invoiceSelected.length > 0? false : true"
                    @click="SubmitInvoices"
                  >
                    Submit
                  </b-button>
                </div>
                <div class="ml-1">
                  <ReportTableButtons
                    :items="items"
                    :json_fieldz="json_fields"
                    :name="`${downloadReportName} - Page ${page}.xls`"
                    :bulkname="`${downloadReportName}.xls`"
                    :fetch="fetchDataForMerchantBusinessNoPagination"
                    @refresh="fetchDataForMerchantBusiness"
                  />
                </div>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-row>
            <b-col md="12">
              <b-overlay
                id="overlay-background"
                blur="10px"
                opacity="0.30"
                rounded="sm"
                variant="light"
              >
                <b-table
                  :per-page="perPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  hover
                  responsive
                  striped
                  show-empty
                  class="table-responsive"
                  @sort-changed="sortChanged"
                >
                  <template #empty>
                    <TableDataFetching
                      :rows="items"
                      :data-loading="dataLoading"
                    />
                  </template>
                  <template #head()="{ field }">
                    <div
                      class="sortable-header"
                    >
                      <span class="header-text">{{ field.label }}</span>
                      <feather-icon
                        v-if="field.sortable"
                        :icon="sort === field.key
                          ? 'ArrowUpIcon'
                          : 'ArrowDownIcon'"
                        size="14"
                      />
                    </div>
                  </template>
                  <template #head(id)>
                    <div class="d-flex align-items-start">
                      <div>
                        <b-form-checkbox
                          id="selectAllCheckbox"
                          v-model="selectAllCheckbox"
                          name="selectAllCheckbox"
                          @change="onClickSelectAllCheckbox()"
                        />
                      </div>
                    </div>
                  </template>
                  <template #cell(id)="data">
                    <div class="d-flex align-items-start">
                      <div>
                        <div class="font-weight-bolder">
                          <b-form-checkbox
                            v-model="invoiceSelected"
                            :value="data.item.id"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(merchant.name)="data">
                    <div class="d-flex align-items-start">
                      <div>
                        <div class="">
                          {{ `${data.value}${data.item.merchant.merchant_setting.merchant_type === 'cash' ? "&nbsp;[&nbsp;C&nbsp;]" : ''}` }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(merchant_business)="data">
                    <span>{{ data.item.merchant_business || '---' }}</span>
                  </template>
                  <template #cell(invoice_no)="data">
                    <div class="d-flex align-items-center">
                      <b-avatar
                        :text="avatarText(data.item.invoice_no)"
                        size="32"
                        variant="light-primary"
                      />
                      <div class="ml-1">
                        <div
                          class="font-weight-bolder text-primary"
                          @click="onClickInvoice(data.item.id)"
                        >
                          {{ data.value }}
                        </div>
                        <div class="font-small-2">
                          {{ __dateTimeFormatter(data.item.created_at) }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(delivery_charge)="data">
                    <span>{{ __numberWithCommas(data.value, true) }}</span>
                  </template>
                  <template #cell(return_charge)="data">
                    <span>{{ __numberWithCommas(data.value, true) }}</span>
                  </template>
                  <template #cell(commission)="data">
                    <span>{{ __numberWithCommas(data.value, true) }}</span>
                  </template>
                  <template #cell(invoice_amount)="data">
                    <span>{{ __numberWithCommas(data.value, true) }}</span>
                  </template>
                  <template #cell(deposited_date)="data">
                    {{ __dateTimeFormatter(data.value) || '---' }}
                  </template>
                  <template #cell(approved_date)="data">
                    {{ __dateTimeFormatter(data.value) || '---' }}
                  </template>
                  <template #cell(finance_current_status.key)="data">
                    <finance-status-badge
                      :status-key="data.value"
                      :finance-status="statusOptions"
                    />
                    <div
                      v-if="data.item.is_reversed_deposit"
                      class="mt-1 d-flex justify-content-center"
                    >
                      <b-tooltip
                        :target="data.item.id.toString()"
                        triggers="hover"
                        variant="danger"
                      >
                        Rejected Once
                      </b-tooltip>
                      <b-avatar
                        :id="data.item.id.toString()"
                        size="20"
                        style="background-color: #ffb5b5"
                      >
                        <feather-icon
                          icon="ChevronsLeftIcon"
                          class="text-body align-middle"
                        />
                      </b-avatar>
                    </div>
                  </template>
                </b-table>
              </b-overlay>
              <div class="mx-2 mb-2">
                <b-row
                  cols="12"
                >
                  <b-col
                    class="d-flex align-items-center justify-content-sm-start"
                    md="3"
                  >
                    <label class="width-75">Per page</label>
                    <v-select
                      v-model="perPage"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="pageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block width-100"
                    />
                  </b-col>
                  <!-- Pagination -->
                  <b-col
                    class="d-flex align-items-center justify-content-sm-end"
                    md="9"
                  >
                    <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                    <b-pagination
                      v-model="page"
                      :total-rows="(meta.total)? meta.total : 0"
                      :per-page="perPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>

                  </b-col>

                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
    <debit-note-detail-modal ref="debit_note_detail_modal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BRow,
  VBModal,
  BButton,
  VBTooltip,
  BPagination,
  BFormCheckbox,
  BTable,
  BOverlay,
  BAvatar,
} from 'bootstrap-vue'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import Ripple from 'vue-ripple-directive'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import DebitNoteDetailModal from '@/components/FinanceModuleForms/InfoModals/DebitNoteDetailModal.vue'
import { heightTransition } from '@core/mixins/ui/transition'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BCol,
    BFormGroup,
    BFormCheckbox,
    BRow,
    AdvancedDateFilter,
    vSelect,
    BCard,
    BButton,
    BPagination,
    BTable,
    BOverlay,
    FilterCard,
    FinanceStatusBadge,
    DebitNoteDetailModal,
    FilterButtons,
    BAvatar,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, heightTransition, tableMixin],
  data() {
    return {
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
        status: null,
      },
      avatarText,
      statusOptions: [],
      selectedMerchant: '',
      selectedMerchantBusiness: '',
      merchantBusinessOptions: [],
      Rider: [],
      deselect: true,
      invoiceSelected: [],
      merchantOptions: [],
      dataLoading: false,
      submitLoading: false,
      sort: '',
      perPage: 10,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'id',
          label: '#',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'invoice_no',
          label: 'Invoice No',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'merchant.name',
          label: 'Merchant',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'merchant_business',
          label: 'Merchant Business',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'commission',
          label: 'Commission',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'delivery_charge',
          label: 'Delivery Charge',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'return_charge',
          label: 'Return Charge',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'invoice_amount',
          label: 'Total Amount',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'deposited_date',
          label: 'Deposited Date',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'approved_date',
          label: 'Approved Date',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'finance_current_status.key',
          label: 'Status',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      items: [],
      json_fields: {
        'Invoice NO': 'invoice_no',
        'Created Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Merchant Reference Number': {
          field: 'merchant.ref_no',
          callback: value => `"${value}"`,
        },
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value}"`,
        },
        'Merchant Business': {
          field: 'merchant_business',
          callback: value => `"${value}"`,
        },
        Commission: 'commission',
        'Delivery Charge': 'delivery_charge',
        'Return Charge': 'return_charge',
        'Total Amount': 'invoice_amount',
        'Deposited Date': {
          field: 'deposited_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Approved Date': {
          field: 'approved_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Status: 'finance_current_status.name',
      },
      selectAllCheckbox: false,
      downloadReportName: 'Merchant-New-Debit-Notes',
      pageWithSelectAll: [],
    }
  },
  watch: {
    deep: true,
    page() {
      this.fetchDataForMerchantBusiness()
    },
    perPage() {
      this.fetchDataForMerchantBusiness()
    },
  },
  mounted() {
    this.statusOptions = JSON.parse(localStorage.getItem('finance_statuses'))
    this.getMerchantList()
    this.updateFilterCount()
  },
  methods: {
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await MerchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async loadBills() {
      if (!this.selectedMerchant) {
        this.showErrorMessage('Please Select a Merchant')
      } else if (!this.selectedMerchantBusiness) {
        this.showErrorMessage('Please Select a Merchant Business')
      } else {
        this.deselectAll()
        await this.fetchDataForMerchantBusiness()
      }
    },
    async fetchDataForMerchantBusiness() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      const isChecked = this.pageWithSelectAll.includes(this.page)
      if (!isChecked) {
        this.selectAllCheckbox = false
      } else {
        this.selectAllCheckbox = true
      }
      if (this.selectedMerchantBusiness) {
        try {
          const { data } = (await FinanceRepository.getMerchantBusinessInvoices(this.page, this.perPage, this.selectedMerchantBusiness, filterQuery))
          this.items = data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      }
      this.dataLoading = false
    },
    async fetchDataForMerchantBusinessNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getMerchantBusinessInvoicesNoPagination(this.selectedMerchantBusiness, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async getMerchantBusinessList() {
      try {
        this.businesses = []
        this.merchant_business_id = null
        this.merchant_id = this.selectedMerchant
        const { data } = (await MerchantRepository.getMerchantBusinessListDropdown(this.merchant_id)).data
        this.merchantBusinessOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickInvoice(invoice) {
      this.$router.push({
        name: 'merchant-finance-invoice',
        params: {
          id: invoice,
        },
      })
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForMerchantBusiness()
    },
    applyFilters() {
      this.fetchDataForMerchantBusiness()
      this.deselectAll()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
        status: null,
      }
      this.$nextTick(() => {
        this.fetchDataForMerchantBusiness()
      })
      this.updateFilterCount()
    },
    selectAll() {
      this.invoiceSelected = this.items.map(n => n.id)
      this.deselect = false
    },
    deselectAll() {
      this.invoiceSelected = []
      this.selectAllCheckbox = false
      this.pageWithSelectAll = []
      this.items = []
      this.meta = {}
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        this.invoiceSelected = [...this.invoiceSelected, ...this.items.map(n => n.id)]
        this.pageWithSelectAll = [...this.pageWithSelectAll, this.page]
      } else {
        this.invoiceSelected = []
        this.pageWithSelectAll = []
      }
    },
    SubmitInvoices() {
      if (this.invoiceSelected.length === 0) {
        this.showErrorMessage('Please Select Invoices First')
      } else if (this.selectedMerchant !== this.items[0].merchant.id) {
        this.showErrorMessage('Selected invoices do not match the selected merchant')
      } else {
        const invoices = {
          merchant_id: this.selectedMerchant,
          merchant_business_id: this.selectedMerchantBusiness,
          invoice_ids: this.invoiceSelected,
        }
        this.handleSubmit(invoices)
      }
    },
    async handleSubmit(invoices) {
      this.$refs.debit_note_detail_modal.openModal(this.invoiceSelected, this.createDebitNote, invoices)
    },
    async createDebitNote(invoices) {
      const res = await FinanceRepository.createMerchantDebitNote(invoices)
      if (res.status === 201) {
        this.showSuccessMessage('Debit Note Created Successfully')
        await this.$router.push('/operations/merchant-debit-notes')
      } else {
        this.showErrorMessage('Cannot Add Debit Note')
        await this.$router.push('/operations/merchant-debit-notes')
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.custom-button-color-blur {
  background-color: #6da5ff !important;
  border-color: #6da5ff !important;
}
@media (max-width: 767px) {
  .mobile-buttons {
    margin-bottom: 2rem;
  }
  .table-responsive {
    position: sticky;
    top: 0;
  }
  .mobile-margin {
    margin-bottom: 20px;
    width: 100%;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
